import React from "react";
import CompaniesHiring from "../Components/CompaniesHiring";

const CompaniesPage = () => {
  return (
    <>
      <CompaniesHiring />
    </>
  );
};

export default CompaniesPage;
